{
  "it": {
    "placeholders": {
      "name": "Nome",
      "description": "Descrizione",
      "amount": "Importo",
      "login": "Username o e-mail",
      "username": "Nome utente",
      "twoFactorCode": "Codice due-fattori",
      "confirmationCode": "Codice di conferma",
      "email": "E-mail",
      "password": "Password",
      "passwordConfirmation": "Conferma Password",
      "homepage": "Homepage",
      "discord": "Server Discord",
      "youtube": "Canale YouTube",
      "twitch": "Canale Twitch",
      "distance": "Distanza",
      "guilded": "Server Guilded",
      "color": "Colore",
      "title": "Titolo",
      "classification": "Combattimento, Industriale, Multiruolo...",
      "focus": "Caccia leggero, Estrazione mineraria, Carico...",
      "minSize": "snub, piccola, media...",
      "maxSize": "media, grande, capitale...",
      "minCrew": "Equipaggio min.",
      "minCargo": "SCU",
      "modelId": "Cerca una nave",
      "scenario": "Xenothreat, Pirate Swarm, Taglia…",
      "briefing": "Briefing dettagliato — comunicazioni, nominativi, regole d'ingaggio…",
      "location": "Stanton, Pyro, ARC-L1…",
      "meetupLocation": "Daymar, Spazioporto — Hangar 4…",
      "maxAttendees": "Limite facoltativo",
      "autoLockMinutesBefore": "60",
      "timezone": "UTC",
      "startsAt": "Scegli data e ora di inizio",
      "endsAt": "Scegli data e ora di fine (facoltativo)",
      "notes": "Porto munizioni extra, posso fare supporto, arrivo tra 10…",
      "signup-status": "Confermata o non definitiva?",
      "features": {
        "username": "Username or User ID",
        "name": "Nome funzione"
      },
      "fleetInviteToken": "Inviti Alla Flotta",
      "quicksearch": {
        "models": "Avenger, Carrack, Cutlass...",
        "hangar": "Enterprise, Andromeda..."
      },
      "search": {
        "default": "Cerca nel Verse...",
        "roadmap-progress-tracker": "Cerca"
      },
      "home": {
        "search": "Cerca Navi..."
      },
      "image": {
        "caption": "Didascalia"
      },
      "model": {
        "length": "Lunghezza",
        "beam": "Larghezza",
        "height": "Altezza",
        "price": "Prezzo",
        "pledgePrice": "Prezzo Pledge",
        "onSale": "In vendita",
        "mass": "Massa",
        "minCrew": "Equipaggio min.",
        "maxCrew": "Equipaggio max.",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "rsiId": "RSI ID",
        "scKey": "SC Key",
        "erkulIdentifier": "Erkul Identifier",
        "productionNote": "Nota di produzione",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "Velocità max.",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "quantumFuelTankSize": "Dimensione serbatoio Quantum",
        "hydrogenFuelTankSize": "Dimensione serbatoio idrogeno",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "Imbardata potenziata",
        "pitchBoosted": "Beccheggio potenziato",
        "rollBoosted": "Rollio potenziato",
        "fleetchartOffsetLength": "Offset lunghezza grafico flotta",
        "fleetchartOffsetBeam": "Offset larghezza grafico flotta",
        "extendedLength": "Lunghezza estesa",
        "extendedBeam": "Larghezza estesa",
        "extendedHeight": "Altezza estesa",
        "extendedFleetchartOffsetLength": "Offset lunghezza grafico flotta esteso",
        "extendedFleetchartOffsetBeam": "Offset larghezza grafico flotta esteso",
        "landedLength": "Lunghezza atterrato",
        "landedBeam": "Larghezza atterrato",
        "landedHeight": "Altezza atterrato",
        "landedFleetchartOffsetLength": "Scostamento lunghezza atterrato",
        "landedFleetchartOffsetBeam": "Scostamento larghezza atterrato",
        "cargo": "Carico",
        "baseModel": "Modello base"
      },
      "cargoHold": {
        "offsetX": "Offset X",
        "offsetY": "Offset Y",
        "offsetZ": "Offset Z",
        "rotation": "0 or 90"
      },
      "manufacturer": {
        "longName": "Nome completo",
        "code": "Codice",
        "scRef": "SC Ref"
      },
      "announcement": {
        "title": "Cosa è successo?",
        "body": "Markdown. Compare nella posta in arrivo e nell'e-mail.",
        "discordPart": "Un messaggio",
        "socialPart": "Un post",
        "link": "/fleets/"
      },
      "fundingGoal": {
        "title": "Costi server, Dominio, Discord...",
        "description": "Contesto facoltativo mostrato pubblicamente",
        "amount": "100.00",
        "currency": "EUR",
        "effectiveFrom": "2026-01-01",
        "endedAt": "lascia vuoto se ancora in corso"
      },
      "supporterContribution": {
        "name": "Nome del sostenitore mostrato pubblicamente",
        "amount": "5.00",
        "currency": "EUR",
        "startedAt": "2026-01-01",
        "endedAt": "2026-12-31",
        "payerEmail": "donor@example.com",
        "claimKey": "FY-7K2M-9QXD",
        "note": "Nota interna facoltativa"
      },
      "component": {
        "componentClass": "Classe componente",
        "componentType": "Tipo componente",
        "componentSubType": "Sottotipo componente",
        "itemType": "Tipo di oggetto",
        "size": "Dimensione",
        "grade": "Grado",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "modelPaint": {
        "pledgePrice": "Prezzo Pledge",
        "productionStatus": "Stato di produzione",
        "productionNote": "Nota di produzione"
      },
      "fleet": {
        "headquarters": "Dove ha base la vostra flotta?",
        "fid": "ID Flotta",
        "rsiSid": "RSI SID",
        "ts": "Server Teamspeak",
        "description": "Descrizione",
        "discord": {
          "guildId": "es. 123456789012345678",
          "channelId": "ID del canale vocale per l'evento",
          "webhookUrl": "https://discord.com/api/webhooks/…",
          "webhookConfigured": "Salvato — lascia vuoto per mantenere quello attuale"
        },
        "guilded": "Server Guilded",
        "homepage": "Homepage",
        "twitch": "Canale Twitch",
        "youtube": "Canale Youtube"
      },
      "adminUser": {
        "passwordConfirmation": "Conferma password"
      },
      "user": {
        "rsiHandle": "Handle RSI",
        "location": "e.g. Berlin, Germany",
        "currentSystem": "es. Lorville, Port Tressler, Pyro"
      },
      "oauthApplication": {
        "name": "La mia applicazione",
        "redirectUri": "https://example.com/callback",
        "scopes": "pubblico"
      },
      "vehicle": {
        "serial": "Seriale"
      },
      "itemPrice": {
        "price": "0.00",
        "location": "Posizione",
        "locationUrl": "URL posizione"
      },
      "video": {
        "url": "YouTube Video ID"
      },
      "modelModule": {
        "name": "Nome del Modulo",
        "price": "0.00",
        "pledgePrice": "0.00",
        "productionStatus": "Annunciato, Pronto al Volo, In Concept...",
        "scKey": "SC Key",
        "search": "Cerca moduli per nome..."
      },
      "modelUpgrade": {
        "name": "Nome upgrade",
        "pledgePrice": "0.00",
        "description": "Descrizione"
      },
      "modelModulePackage": {
        "name": "Nome pacchetto",
        "pledgePrice": "0.00",
        "description": "Descrizione"
      },
      "dock": {
        "name": "Nome dock",
        "length": "Lunghezza in m",
        "beam": "Larghezza in m",
        "height": "Altezza in m"
      },
      "modelPosition": {
        "name": "Nome posizione",
        "position": "0"
      },
      "logistics": {
        "inventoryName": "Main Depot, Cargo Bay...",
        "description": "Optional details about this inventory",
        "location": "e.g. Port Olisar, Area18",
        "itemName": "Titanium, Medical Supplies..."
      },
      "filters": {
        "vehicles": {
          "name": "Enterprise, Andromeda...",
          "priceLt": "Prezzo <=",
          "priceGt": "Prezzo >="
        },
        "models": {
          "name": "Gladius, Andromeda...",
          "classification": "Veicolo, Caccia, Cargo...",
          "manufacturer": "Origin, Robert Space Industries, Aegis...",
          "onSale": "Sì o No",
          "productionStatus": "Annunciato, Pronto al volo, In fase di progettazione..."
        },
        "modelModules": {
          "name": "Bio Dome, Cargo Module..."
        },
        "manufacturers": {
          "name": "Origin, Robert Space Industries, Aegis..."
        },
        "supporterContributions": {
          "name": "Alice, Bob...",
          "startedAtGteq": "2026-01-01",
          "startedAtLteq": "2026-12-31"
        },
        "adminNotifications": {
          "search": "Titolo o contenuto..."
        },
        "users": {
          "search": "Nome utente o e-mail",
          "username": "Nome utente",
          "rsiHandle": "Handle RSI",
          "email": "E-mail"
        },
        "components": {
          "name": "Nome",
          "description": "motore quantico, corazzatura...",
          "manufacturer": "Behring, Ascension Astro, Juno Starwerk..."
        },
        "fleets": {
          "name": "Nome",
          "fid": "FID",
          "memberCountGteq": "Membri minimi",
          "memberCountLteq": "Membri massimi",
          "createdOnGteq": "2026-01-01",
          "createdOnLteq": "2026-12-31",
          "members": {
            "search": "Nome utente o soprannome"
          }
        },
        "destroyedFleets": {
          "nameOrFid": "Nome o FID"
        },
        "commodities": {
          "name": "Agricium, Laranite, Quantainium...",
          "description": "ore, ammunition, material...",
          "uexCode": "UEX Code"
        },
        "equipment": {
          "name": "Arclight, Pembroke, Novikov..."
        },
        "notifications": {
          "search": "Titolo o contenuto..."
        },
        "blueprints": {
          "name": "Greatsword, Testudo, Omnisky...",
          "material": "Ferro, Titanio, Aphorite...",
          "craftableType": "Componente, Equipaggiamento...",
          "source": "Nota, ignota..."
        },
        "fleetDirectory": {
          "search": "Nome, FID o SID...",
          "memberCountGteq": "Membri minimi"
        }
      },
      "commodity": {
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "equipment": {
        "equipmentType": "Equipment Type",
        "itemType": "Item Type",
        "subType": "Sub Type",
        "weaponClass": "Weapon Class",
        "size": "Size",
        "grade": "Grade",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "relationships": {
        "user": {
          "handle": "Nome utente della persona"
        },
        "fleet": {
          "handle": "Identificativo della flotta"
        }
      },
      "reward": "Ricompensa in aUEC",
      "crewLimit": "Nessun limite",
      "deadline": "Nessuna scadenza",
      "itemName": "Cosa consegnare",
      "itemQuantity": "Quanto",
      "itemQuality": "600"
    }
  }
}
